<!--
 * 打印组件
-->
<template>
    <div>
        <!-- 拣货单 -->
		<div v-for="(item, index) in PrintingForm" :key="index" id="pritings">
			<div :id="gernerateId(index + 1)" style="display: none; padding-bottom: 30px;">
				<div style="width:190mm">
                    <h3 style="text-align: center;margin-left:30px">湖南海润医药有限公司拣货单</h3>
                    <div style="width:190mm;margin-left:30px">
                        <div style="display:flex;justify-content: space-between;">
                            <div>订单编号：{{ item.orderNo }}</div>
                            <div>买家手机：{{ item.buyerPhone }}</div>
                            <div>买家姓名：{{ item.buyerName }}</div>
                        </div>
                        <div style="display:flex;;padding-top:5px">
                            <div>收货地址：{{ item.buyerAddress }}</div>
                        </div>
                        <div style="display:flex;padding-top:5px;justify-content: space-between;">
                            <div>发货日期：{{ item.deliveryTime }}</div>
                            <div>物流单号：{{ item.trackingCode }}</div>
                            <div>序号:{{ item.printNum }} 包装类型：{{ item.packageType }}</div>
                        </div>
                    </div>
                </div>
                <div style="display: none; margin-top: 50px;" :id="tb(index + 1)">
                    <div style="width:100%;padding-bottom: 10px">
                        <table style="width:100%; border: 1px solid #000;border-collapse: collapse;font-size:12px">
                            <tr>
                            <td v-for="item in PrintingTableHead" :key="item.name" style="text-align: center;height: 25px;border: 1px solid #000;">
                                {{ item.name }}
                            </td>
                            </tr>
                            <tr v-for="(items, index) in item.dataList" :key="index">
                            <td style="text-align: center;height: 25px;border: 1px solid #000;">
                                {{ items.xh }}
                            </td>
                            <td style="text-align: center;height: 25px;border: 1px solid #000;">
                                {{items.accountName}}
                            </td>
                            <td style="text-align: center;height: 25px;border: 1px solid #000;">
                                {{ items.productName }}
                            </td>
                            <td style="text-align: center;height: 25px;border: 1px solid #000;">
                                {{ items.productCode }}
                            </td>
                            <td style="text-align: center;height: 25px;border: 1px solid #000;">
                                {{ items.batchNum }}
                            </td>
                            <td style="text-align: center;height: 25px;border: 1px solid #000;">
                                {{ items.productNum }}
                            </td>
                            <td style="text-align: center;height: 25px;border: 1px solid #000;">
                                {{ items.goodsAllocation }}
                            </td>
                            <td style="text-align: center;height: 25px;border: 1px solid #000;">
                                {{ items.specifications }}
                            </td>
                            <td style="text-align: center;height: 25px;border: 1px solid #000;">
                                {{ items.manufacturer }}
                            </td>
                            </tr>
                        </table>
                    </div>
                </div>
            </div>
        </div>
        <!-- 商品清单 -->
        <div id="div1" style="display: none">
            <div style="width:190mm">
                <div style="text-align: center;margin-left:60px;font-size:24px">湖南新诚智慧健康药房管理有限公司</div>
                <div style="text-align: center;margin-left:60px;font-size:24px">新诚智慧糖尿病管理中心</div>
                <div style="width:190mm;margin-left:30px;padding-top:5px">
                <div style="display:flex;justify-content: space-between;">
                    <div>订单编号：{{goodslist.orderNo}}</div>
                    <div>买家手机：{{goodslist.buyerPhone}}</div>
                    <div>买家姓名：{{goodslist.buyerName}}</div>
                </div>
                <div style="display:flex;;padding-top:5px">
                    <div>收货地址：{{goodslist.buyerAddress}}</div>
                </div>
                <div style="display:flex;padding-top:5px">
                    <div>发货日期：{{goodslist.deliveryTime}}</div>
                </div>
                <div style="display:flex;padding-top:5px">
                    <div>包装类型：{{ goodslist.packageType }}</div>
                </div>
                </div>
            </div>
        </div>
        <div id="div2" style="display:none">
            <TABLE border=1 cellSpacing=0 cellPadding=1 width="100%" style="border-collapse:collapse">
                <thead>
                <tr>
                    <td v-for="item in goodsTableHead" :key="item.name" style="text-align: center;height: 25px;border: 1px solid #000;">
                    {{ item.name }}
                    </td>
                </tr>
                </thead>
                <TBODY>
                <tr v-for="(items, index) in goodslist.details" :key="index">
                    <td style="text-align: center;height: 25px;border: 1px solid #000;">
                    {{ items.xh }}
                    </td>
                    <td style="text-align: center;height: 25px;border: 1px solid #000;">
                      {{items.accountName}}
                    </td>
                    <td style="text-align: center;height: 25px;border: 1px solid #000;">
                    {{ items.productName }}
                    </td>
                    <td style="text-align: center;height: 25px;border: 1px solid #000;">
                    {{ items.productNum }}
                    </td>
                    <td style="text-align: center;height: 25px;border: 1px solid #000;">
                    {{ items.specifications }}
                    </td>
                    <td style="text-align: center;height: 25px;border: 1px solid #000;">
                    {{ items.manufacturer }}
                    </td>
                    <td style="text-align: center;height: 25px;border: 1px solid #000;">
                    {{ items.other }}
                    </td>
                </tr>
                </TBODY>
            </TABLE>
        </div>
        <div id="div3" style="display: none">
            <div style="width:190mm">
                <div style="width:190mm;margin-left:30px;padding-top:5px">
                <div style="display:flex;justify-content: space-between;">
                    <div>客户编号：{{goodslist.customerCode}}</div>
                    <div>质量监督电话：400 690 1009</div>
                </div>
                <div style="margin-top:5px;text-align: center;height:30px;background:#E6E7E9;line-height:30px">用 " 新 " 守护健康</div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { getLodop } from "@/assets/js/LodopFuncs";
export default{
    name: "print",
    data() {
        return {
            goodslist:{},
            PrintingForm:[],
            PrintingTableHead: [
                { name: "序号" },
                { name: "账套" },
                { name: "商品名称" },
                { name: "商品代码" },
                { name: "批号" },
                { name: "数量" },
                { name: "货位" },
                { name: "规格" },
                { name: "生产厂家" },
            ],
            goodsTableHead: [
                { name: "序号" },
                { name: "账套" },
                { name: "商品名称" },
                { name: "数量" },
                { name: "规格" },
                { name: "生产厂家" },
                { name: "其他" },
            ],
            printShipping:{},
            ztPrintShipping:{},
            printArr:[],
            timer:null
        };
    },
    watch: {
        goodslist:function() {
            this.$nextTick(function(){
                LODOP = getLodop();
                LODOP.NewPage()
                LODOP.SET_PRINT_PAGESIZE(1, "210mm", "148mm", "A5");
                LODOP.ADD_PRINT_IMAGE( 0, 0,160,110, "<img border='0' width='160px' height='50px' src='https://xinchengzhihui.oss-cn-hangzhou.aliyuncs.com/pdtp/2023/08/23/36fa44ae1156435b9da75fbbaf0d60f7.png'/>")
                LODOP.ADD_PRINT_HTM("0mm",'6mm',"RightMargin:0","BottomMargin:0mm", document.getElementById("div1").innerHTML);
                LODOP.SET_PRINT_STYLEA(0, "ItemType", 1);
                LODOP.SET_PRINT_STYLEA(0, "Horient", 1);
                LODOP.ADD_PRINT_TABLE('35mm', "6mm", "190mm", '96mm', document.getElementById("div2").innerHTML);
                LODOP.SET_PRINT_STYLEA(0, "Vorient", 3);
                LODOP.ADD_PRINT_HTM("121mm",'6mm',"RightMargin:0","BottomMargin:0mm", document.getElementById("div3").innerHTML);
                LODOP.SET_PRINT_STYLEA(0, "ItemType", 1);
                LODOP.SET_PRINT_STYLEA(0, "Horient", 1);
                // LODOP.PREVIEW();
                LODOP.PRINT()
                if (LODOP.CVERSION){
                    CLODOP.On_Return_Remain = true;
                    CLODOP.On_Return=function(TaskID,Value){
                        // if(Value==0){
                        //     that.$emit('successPrint','fail')
                        // } else {
                        //     that.$emit('successPrint','success')
                        // }
                    }
                }
            })
        },
        PrintingForm: function() {
            var that = this;
            this.$nextTick(function(){
                that.CreateOneFormPage()
                // LODOP.PREVIEW()
                if (LODOP.CVERSION){
                    CLODOP.On_Return_Remain = true;
                    CLODOP.On_Return=function(TaskID,Value){
                        // if(Value==0){
                        //     console.log("打印失败")
                        //     that.$emit('successPrint','fail')
                        // } else {
                        //     that.$emit('successPrint','success')
                        // }
                    }
                }
            })
        }
    },
    mounted() {

        this.linkType = localStorage.getItem('websocket-link-type');
        this.startTimer(this.print);
    },
    methods:{
        startTimer(fun) {
            this.timer = setInterval(fun, 5000);
        },
        async print() {
            var printArr = [];

            for(var item in this.printArr) {
                printArr.push(item);
            }

            console.log('打印启动:' + printArr.length);
            if(printArr.length > 0 && this.linkType) {
                this.stopTimer(this.timer);
                for(var i = 0; i < printArr.length; i++) {
                    var orderId = this.printArr.splice(0, 1);
                    if(orderId.length <= 0) {
                        continue;
                    }

                    var orderNo = orderId[0];
                    console.log(this.linkType)
                    if(this.linkType == '10001') {
                        await this.reqSFOrderInfo(orderNo);
                    } else if(this.linkType == '10003') {
                        await this.reqPinkOrderInfo(orderNo);
                    } else if(this.linkType == '10006') {
                        await this.reqPinkOrderInfos(orderNo);
                    }
                    console.log("打印" + orderNo);
                }
            }

            if(this.timer == null) {
                this.startTimer(this.print);
            }
        },
        stopTimer(timer) {
            console.log("停止timer")
            this.timer = null;
            clearInterval(timer);
        },
        // 打印清单
        Pinventory(id){
            let that = this
            this.request(this.Appconstance.REQUEST_TYPE.GET, this.adminApi.CRMORDER.printGoodsList + id, {}, true, true).then(res=>{
                that.goodslist = res.data
                setTimeout(() => {
                    
                }, 1000)
            })
        },
        // 打印面单号
        printWaybill(id) {
            if (getLodop().ADD_PRINT_PDF == undefined) {
                return this.MGridUtil.MessageBox(
                "请升级您的LODOP打印控件!",
                function sure() {
                    window.open("http://www.lodop.net/download.html");
                }
                );
            }

            this.printArr.push(id);
        },

        async reqSFOrderInfo(id) {
            let that = this
            const res = await this.request(this.Appconstance.REQUEST_TYPE.GET, this.adminApi.CRMORDER.printFaceSheet + id, {}, true, true)
            if (res.status == '200') {
                let type = res.mapInfo.type;
                if (type == "1") {
                    const strURL = res.mapInfo.resourceUrl;
                    if(!strURL) {
                        console.log("面单不存在:" + id);
                        return;
                    }

                    LODOP = getLodop();
                    LODOP.PRINT_INIT("顺丰面单打印");
                    LODOP.SET_PRINT_PAGESIZE(1, "76mm", "130mm", "");
                    LODOP.ADD_PRINT_PDF(0, 0, "76mm", "130mm", strURL);
                    LODOP.SET_PRINT_MODE("PRINT_PAGE_PERCENT", "Auto-Height");
                    // LODOP.PREVIEW()
                    var taskCode = LODOP.PRINT();
                    this.printShipping[taskCode] = id;
                    console.log("---------", this.printShipping)
                    if (LODOP.CVERSION){
                        CLODOP.On_Return_Remain = true;
                        var printCodeMap = this.printShipping;
                        console.log(printCodeMap);
                        CLODOP.On_Return=function(TaskID,Value){
                            var orderNo = printCodeMap[TaskID]
                            console.log("打印结果:", TaskID);
                            console.log("打印结果:", Value);
                            console.log("打印订单:", orderNo);
                            delete printCodeMap[TaskID];
                            if(Value==0){
                                that.$emit('successPrint','fail', orderNo)
                            } else {
                                that.$emit('successPrint','success', orderNo)
                            }
                        }
                    }
                }
            }
        },
        async printZts(id){
            let that = this
            const res = await this.request(this.Appconstance.REQUEST_TYPE.GET, this.adminApi.gyOrder.printLogisticsNumber + id, {}, true, true)
            if (res.status == '200') {
                if (res.rows.length > 0) {
                    var taskCode = this.ztPrintData(res.rows[0]);
                    this.ztPrintShipping[taskCode] = id;
                    if (LODOP.CVERSION){
                        CLODOP.On_Return_Remain = true;
                        var ztPrintCodeMap = this.ztPrintShipping;
                        CLODOP.On_Return=function(TaskID,Value){
                            var orderNo = ztPrintCodeMap[TaskID]
                            console.log("中通打印结果:", TaskID);
                            console.log("中通打印结果:", Value);
                            console.log("中通打印订单:", orderNo);
                            delete ztPrintCodeMap[TaskID];
                            if(Value==0){
                                that.$emit('successPrint','fail', orderNo)
                            } else {
                                that.$emit('successPrint','success', orderNo)
                            }
                        }
                    }
                }
            }
        },
        async printZt(id) {
            let that = this
            const res = await this.request(this.Appconstance.REQUEST_TYPE.GET, this.adminApi.CRMORDER.printFaceSheet + id, {}, true, true)
            if (res.status == '200') {
                let type = res.mapInfo.type;
                if (type == "2" && res.rows.length > 0) {
                    var taskCode = this.ztPrintData(res.rows[0]);
                    this.ztPrintShipping[taskCode] = id;
                    if (LODOP.CVERSION){
                        CLODOP.On_Return_Remain = true;
                        var ztPrintCodeMap = this.ztPrintShipping;
                        CLODOP.On_Return=function(TaskID,Value){
                            var orderNo = ztPrintCodeMap[TaskID]
                            console.log("中通打印结果:", TaskID);
                            console.log("中通打印结果:", Value);
                            console.log("中通打印订单:", orderNo);
                            delete ztPrintCodeMap[TaskID];
                            if(Value==0){
                                that.$emit('successPrint','fail', orderNo)
                            } else {
                                that.$emit('successPrint','success', orderNo)
                            }
                        }
                    }
                }
            }
        },
        async reqPinkOrderInfo(id) {
            var that = this;
            await that.request(that.Appconstance.REQUEST_TYPE.GET, that.adminApi.CRMORDER.printPickingList + id, {}, true, true).then(res=>{
                let arr = []
                arr.push(res.data)
                that.PrintingForm = arr
                console.log("拣货单--->" + id);
                setTimeout(() => {
                    
                }, 500)
            })  
        },
        async reqPinkOrderInfos(id) {
            var that = this;
            await that.request(that.Appconstance.REQUEST_TYPE.GET, that.adminApi.gyOrder.printPickingList + id, {}, true, true).then(res=>{
                let arr = []
                arr.push(res.data)
                that.PrintingForm = arr
                console.log("拣货单--->" + id);
                setTimeout(() => {
                    
                }, 500)
            })  
        },
        // 打印拣货单
        pritingPick(id){
            this.printArr.push(id);
        },
        CreateOneFormPage() {
            for (let i=1;i<=this.PrintingForm.length;i++){
                LODOP = getLodop();
                LODOP.NewPage()
                LODOP.SET_PRINT_PAGESIZE(1, "210mm", "297mm", "A5");
                LODOP.ADD_PRINT_TABLE('45mm', "6mm", "190mm", '260mm', document.getElementById("tb"+i).innerHTML);
                LODOP.SET_PRINT_STYLEA(0, "Vorient", 3);
                LODOP.ADD_PRINT_HTM("-10mm",'6mm',"RightMargin:0","55mm", document.getElementById("thd"+i).innerHTML);
                LODOP.SET_PRINT_STYLEA(0, "ItemType", 1);
                LODOP.SET_PRINT_STYLEA(0, "Horient", 1);
                LODOP.SET_PRINT_STYLEA(0, "ItemType", 1);
                LODOP.SET_SHOW_MODE("LANDSCAPE_DEFROTATED", 1);
                LODOP.PRINT()
            }
        },
        ztPrintData(row) {
            LODOP.PRINT_INIT('中通快递包裹');
            LODOP.SET_PRINT_PAGESIZE(1, "76mm", "130mm", "1");
            LODOP.PRINT_INITA(0, 0, "76mm", "130mm", "2");
            LODOP.SET_PRINT_PAGESIZE(1, 760, 1300, "","3");
            LODOP.SET_PRINT_MODE("PRINT_NOCOLLATE", 1);
            LODOP.ADD_PRINT_LINE("10mm", 0, "10mm", "76mm", 0, 1);
            // LODOP.ADD_PRINT_TEXT( "7mm", "1mm","76mm", "6mm",data.printTime);//时间
            LODOP.SET_PRINT_STYLEA(0, "FontSize", 8)
            LODOP.SET_PRINT_STYLEA(0, "FontColor", "#303133")
            LODOP.ADD_PRINT_LINE("20mm", 0, '20mm', "76mm", 0, 1);
            LODOP.ADD_PRINT_TEXT( "10mm", "1mm","76mm", "8mm",row.mark);//251-a33
            LODOP.SET_PRINT_STYLEA(0, "FontSize", 20)
            LODOP.SET_PRINT_STYLEA(0, "FontName", "Arial Black",5);
            LODOP.ADD_PRINT_LINE("38mm", 0, "38mm", "56mm", 0, 1);
            LODOP.ADD_PRINT_BARCODE("22mm", "2mm","54mm", "14mm","128AUTO",row.billCode)
            LODOP.ADD_PRINT_BARCODE("30mm", "60mm","14mm", "62mm","128AUTO",row.billCode)
            LODOP.SET_PRINT_STYLEA(0, "Angle", 270)
            LODOP.SET_PRINT_STYLEA(0, "FontSize", 10)
            LODOP.SET_PRINT_STYLEA(0, "FontColor", "#303133")
            LODOP.ADD_PRINT_LINE("48mm", 0, "48mm", "56mm", 0, 1);
            LODOP.ADD_PRINT_TEXT( "40mm", "1mm","76mm", "6mm",'');
            LODOP.SET_PRINT_STYLEA(0, "FontSize", 14)
            LODOP.SET_PRINT_STYLEA(0, "FontName", "黑体")
            LODOP.SET_PRINT_STYLEA(0, "Bold", 1)
            LODOP.ADD_PRINT_LINE("58mm", 0, "58mm", "56mm", 0, 1);
            LODOP.ADD_PRINT_TEXT( "50mm", "1mm","76mm", "8mm",row.bagAddr);
            LODOP.SET_PRINT_STYLEA(0, "FontSize", 16)
            LODOP.SET_PRINT_STYLEA(0, "FontName", "黑体")
            LODOP.SET_PRINT_STYLEA(0, "Bold", 1)
            LODOP.ADD_PRINT_TEXT( "60mm", "1mm","76mm", "8mm",'收')
            LODOP.SET_PRINT_STYLEA(0, "FontSize", 18)
            LODOP.SET_PRINT_STYLEA(0, "FontName", "黑体")//sendPhone
            LODOP.ADD_PRINT_TEXT( "60mm", "8mm","50mm", "6mm",row.receiverName+' '+row.receiverPhone)
            LODOP.SET_PRINT_STYLEA(0, "FontSize", 12)
            LODOP.SET_PRINT_STYLEA(0, "FontName", "黑体")
            LODOP.SET_PRINT_STYLEA(0, "Bold", 1)
            LODOP.ADD_PRINT_TEXT( "70mm", "8mm","50mm", "8mm",row.receiverAddr)
            LODOP.SET_PRINT_STYLEA(0, "FontSize", 8)
            LODOP.SET_PRINT_STYLEA(0, "FontName", "黑体")
            LODOP.ADD_PRINT_LINE("78mm", 0, "78mm", "56mm", 0, 1,12);
            LODOP.ADD_PRINT_TEXT( "80mm", "1mm","76mm", "8mm",'寄')
            LODOP.SET_PRINT_STYLEA(0, "FontSize", 18)
            LODOP.SET_PRINT_STYLEA(0, "FontName", "黑体")
            LODOP.ADD_PRINT_TEXT( "80mm", "8mm","50mm", "6mm", row.sendName+' '+row.sendAddr)
            LODOP.SET_PRINT_STYLEA(0, "FontSize", 8)
            LODOP.SET_PRINT_STYLEA(0, "FontColor", "#303133")
            LODOP.ADD_PRINT_TEXT( "85mm", "8mm","50mm", "8mm",)
            LODOP.SET_PRINT_STYLEA(0, "FontSize", 8)
            LODOP.SET_PRINT_STYLEA(0, "FontColor", "#303133")
            LODOP.ADD_PRINT_LINE("98mm", 0, "98mm", "76mm", 0, 1);
            LODOP.ADD_PRINT_LINE("20.1mm", '56mm','98mm','56mm', 0, 1);
            LODOP.ADD_PRINT_TEXT( "99mm", "1mm","76mm", "30mm", row.remark)
            LODOP.SET_PRINT_STYLEA(0, "FontSize", 8)
            LODOP.SET_PRINT_STYLEA(0, "FontColor", "#303133")
            LODOP.SET_LICENSES("","EE0887D00FCC7D29375A695F728489A6","C94CEE276DB2187AE6B65D56B3FC2848","")
            return LODOP.PRINT()
        },
        gernerateId (index){
            return "thd" +index
        },
        tb(index){
            return "tb" +index
        },
    }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/printCom/index.vue